/*
 *
 * Hedera Stablecoin SDK
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { lazyInject } from '../../../../../core/decorator/LazyInjectDecorator.js';
import { QueryHandler } from '../../../../../core/decorator/QueryHandlerDecorator.js';
import { MirrorNodeAdapter } from '../../../../../port/out/mirror/MirrorNodeAdapter.js';
import { RPCQueryAdapter } from '../../../../../port/out/rpc/RPCQueryAdapter.js';
import StableCoinService from '../../../../service/StableCoinService.js';
import { IsUnlimitedQuery, } from './IsUnlimitedQuery.js';
let IsUnlimitedQueryHandler = class IsUnlimitedQueryHandler {
    constructor(stableCoinService, mirrorNode, queryAdapter) {
        this.stableCoinService = stableCoinService;
        this.mirrorNode = mirrorNode;
        this.queryAdapter = queryAdapter;
    }
    async execute(command) {
        const { targetId, tokenId } = command;
        const coin = await this.stableCoinService.get(tokenId);
        if (!coin.evmProxyAddress)
            throw new Error('Invalid token id');
        const res = await this.queryAdapter.isUnlimited(coin.evmProxyAddress, await this.mirrorNode.accountToEvmAddress(targetId));
        return Promise.resolve({ payload: res });
    }
};
IsUnlimitedQueryHandler = __decorate([
    QueryHandler(IsUnlimitedQuery),
    __param(0, lazyInject(StableCoinService)),
    __param(1, lazyInject(MirrorNodeAdapter)),
    __param(2, lazyInject(RPCQueryAdapter)),
    __metadata("design:paramtypes", [StableCoinService,
        MirrorNodeAdapter,
        RPCQueryAdapter])
], IsUnlimitedQueryHandler);
export { IsUnlimitedQueryHandler };
